import styled from "styled-components"

export const StructureTable = styled.table`
  border-collapse: collapse;
  margin: 0 auto;
  font-size: 12px;
`

export const StructureHeaderCell = styled.th`
  text-align: center;
  background-color: #f2f2f2;
  padding: 1rem;
  font-weight: 600;
`

export const StructureRow = styled.tr`
  border-bottom: 1px solid rgba(0, 0, 0, .1);
  &.header, &.last{
    border:none;
  }
`

export const StructureCell = styled.td`
  padding: 1rem;
  background-color: #fff;
  text-align: center;
  font-weight: 400;

  &.rowName{
    font-weight: 600;
    text-align: left;
    background-color: #f2f2f2;
  }
`
